import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bandwidth-report-filter',
  templateUrl: './bandwidth-report-filter.component.html',
  styleUrls: ['./bandwidth-report-filter.component.scss']
})
export class BandwidthReportFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
